import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { STORAGE_KEY } from '../../constants/storageKeys';

export class MultiTabBanner {
  private i18n: I18nService;
  private element: HTMLElement | null = null;
  private listener: ((event: StorageEvent) => void) | null = null;

  constructor(i18n: I18nService) {
    this.i18n = i18n;
  }

  initialize(): void {
    this.listener = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY && event.newValue) {
        this.show();
      }
    };
    window.addEventListener('storage', this.listener);
  }

  show(): void {
    if (this.element) return;

    this.element = document.createElement('div');
    this.element.id = 'multitab-banner';
    this.element.className = 'banner banner--warning';
    this.element.setAttribute('role', 'alert');
    this.element.innerHTML = `
      <span class="banner__content">${this.i18n.t(I18N_KEYS.MULTITAB_STATE_CHANGED)}</span>
      <button class="banner__btn" type="button">${this.i18n.t(I18N_KEYS.MULTITAB_RELOAD)}</button>
    `;

    this.element.querySelector('.banner__btn')?.addEventListener('click', () => {
      location.reload();
    });

    document.body.prepend(this.element);
  }

  hide(): void {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }

  destroy(): void {
    if (this.listener) {
      window.removeEventListener('storage', this.listener);
    }
    this.hide();
  }
}
